<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <p>{{data.message}}</p>
</div>
<div mat-dialog-actions class="p-0 justify-content-end">
    <button mat-button color="accent" (click)="close()" cdkFocusInitial>Aceptar</button>
</div>